import { NgModule } from '@angular/core';
import { languageContextConfigFactory } from '@app/core/factories/language-context-config.factory';
import { environment } from '@app-src/environments/environment';
import { DpCMSPages } from '@app/core/types/common/dp-cms-pages.config';
import { b2bCheckoutConfig } from '@app/checkout.config';
import { occBackendConfig } from './config';
import { translationChunksConfig } from '@spartacus/assets';
import { quickOrderTranslationChunksConfig } from '@spartacus/cart/quick-order/assets';
import { savedCartTranslationChunksConfig } from '@spartacus/cart/saved-cart/assets';
import { cartBaseTranslationChunksConfig } from '@spartacus/cart/base/assets';
import {
  FeaturesConfig,
  I18nConfig,
  OccConfig,
  provideConfig,
  provideConfigFactory,
  RoutingConfig,
  WindowRef
} from '@spartacus/core';
import { orderTranslationChunksConfig } from '@spartacus/order/assets';
import { defaultB2bOccConfig } from '@spartacus/setup';
import { storeFinderTranslationChunksConfig } from '@spartacus/storefinder/assets';
import { StoreFinderConfig } from '@spartacus/storefinder/core';
import { defaultCmsContentProviders, layoutConfig, mediaConfig } from '@spartacus/storefront';
import { userAccountTranslationChunksConfig } from '@spartacus/user/account/assets';
import { userProfileTranslationChunksConfig } from '@spartacus/user/profile/assets';

@NgModule({
  providers: [
    ...defaultCmsContentProviders,
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    provideConfig(defaultB2bOccConfig),
    provideConfig(b2bCheckoutConfig),
    provideConfig(occBackendConfig),
    provideConfig(<OccConfig>{
      backend: {
        occ: {
          baseUrl: environment.baseUrl,
          prefix: '/occ/v2/'
        }
      },
      pwa: {
        enabled: false
      }
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        backend: { loadPath: '/translations/{{lng}}/{{ns}}.json?20072023' },
        chunks: {
          ...translationChunksConfig,
          ...savedCartTranslationChunksConfig,
          quickOrder: [...quickOrderTranslationChunksConfig.quickOrder, 'dpAddEntry'],
          ...orderTranslationChunksConfig,
          userProfile: [...userProfileTranslationChunksConfig.userProfile, 'dpDistributors'],
          userAccount: [...userAccountTranslationChunksConfig.userAccount, 'dpLoginForm'],
          checkout: [
            'checkoutAddress',
            'checkoutOrderConfirmation',
            'checkoutReview',
            'checkoutShipping',
            'checkout',
            'checkoutPO',
            'checkoutProgress',
            'dpCheckoutOrderComment',
            'dpShippingAccounts'
          ],
          product: [
            ...translationChunksConfig.product,
            'dpProductAnchors',
            'dpProductDownloads',
            'dpProductDeliveryCenters',
            'dpProductCommon',
            'dpProductInfo',
            'dpProductSummary',
            'dpProductCart',
            'dpProductDetails',
            'dpSearchBox',
            'dpCuttingConditions',
            'dpPLP',
            'dpFilters'
          ],
          productImageZoom: ['productImageZoomTrigger', 'productImageZoomDialog'],
          common: [
            ...translationChunksConfig.common,
            'dpSocialMedia',
            'dpForms',
            'dpRegister',
            'dpLogin',
            'dpReviewOrder',
            'dpCommon',
            'dpFormErrorsShippingAddress',
            'dpNews',
            'dpStoreFinder',
            'subCategories'
          ],
          cart: [
            ...cartBaseTranslationChunksConfig.cart,
            'dpAddedToCart',
            'dpShippingAddress',
            'dpOrderHistory',
            'dpInfoMessages',
            'dpAddEntry'
          ],
          storeFinder: [...storeFinderTranslationChunksConfig.storeFinder],
          savedCarts: [...savedCartTranslationChunksConfig.savedCart],
          address: [...userProfileTranslationChunksConfig.address, 'dpPostalCodeErrors']
        },
        fallbackLang: 'en'
      }
    }),

    provideConfig(<FeaturesConfig>{
      features: {
        level: '4.3',
        displayPromotionsInPdp: true,
        recentSearches: true
      }
    }),
    provideConfig(<RoutingConfig>{
      routing: {
        routes: {
          contact: { paths: ['contact'] },
          cart: { paths: ['cart'] },
          newsOverview: { paths: ['news'] },
          shopClosed: { paths: [DpCMSPages.ShopClosed.path] }
        }
      }
    }),
    provideConfigFactory(languageContextConfigFactory, [WindowRef])
  ]
})
export class SpartacusConfigurationModule {}
